export { default } from "./GlobalFooter";
export { default as GlobalFooterItem } from "./GlobalFooterItem";
export { default as rehydrator } from "./GlobalFooter.rehydrator";
